import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import CoreValues from './components/CoreValues/CoreValues';
import Services from './components/Services/Services';
import OurClients from './components/OurClients/OurClients';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <CoreValues />
        <Services />
        <OurClients />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
